/**
 * Real-time chat module
 * Deps:
 *  - Angular Material (mat-icon, mat-slider)
 *  - momentjs
 *  - recordrtc
 *  - firebase
 *  - firebase Service (sharedModule)
 *  - scrollDirective (sharedModule)
 *  - localeDatePipe (sharedModule)
 *  - _variables.scss (assets)
 */
import { AudioRecorderService } from './services/audio-recorder.service';
import { ChatComponent } from './containers/chat/chat.component';
import { ChatService } from './services/chat.service';
import { CommonModule } from '@angular/common';
import { FileSizePipe } from './pipe/file-size';
import { FirebaseService } from '@app/shared/firebase/firebase.service';
import { MessageListComponent } from './components/message-list/message-list.component';
import { MsgComponent } from './components/msg/msg.component';
import { NgModule } from '@angular/core';
import {SharedModule} from "@shared/shared.module";
import {ParseChatService} from "@shared/parse/parse-chat.service";
import {environment} from "@environments/environment";
import {CHAT_SERVICE} from "@app/services/injection-token";
import {ChatParseServiceImpl} from "@app/services/chat.parse.service";
import {ChatFirebaseServiceImpl} from "@app/services/chat.firebase.service";
import {TranslateLoader, TranslateModule, TranslatePipe} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";

@NgModule({
  declarations: [
    ChatComponent,
    MsgComponent,
    MessageListComponent,
    FileSizePipe,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
      ChatComponent,
      MsgComponent
  ],
  providers: [
    ChatService,
    FirebaseService,
    ParseChatService,
    AudioRecorderService,
    TranslatePipe,
    {
      provide: CHAT_SERVICE,
      useClass: environment.authProvider == 'parse' ? ChatParseServiceImpl : ChatFirebaseServiceImpl
    },
  ]
})
export class ChatModuleModule { }

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
